var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CustomIonInfiniteScroll',{ref:"infiniteScroll",attrs:{"disabled":_vm.disabled,"spinner":!_vm.hideSpinner && _vm.loading,"threshold":_vm.thresholdValue},on:{"ionInfinite":function($event){return _vm.$emit('onLoadMore', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }